import "./SidebarMobile.css";
import { useContext } from "react";
import { Link } from "react-router-dom";
import home from "../../../../../assets/home.png";
import product from "../../../../../assets/product.png";
import affiliate from "../../../../../assets/affiliate.png";
import payouts from "../../../../../assets/payouts.png";
import referral from "../../../../../assets/referral.png";
import settings from "../../../../../assets/settings.png";
import logo from "../../../../../assets/shap_logo.png";
import cancel from "../../../../../assets/cancel.png";
import { UserContext } from "../../../../context/UserContext";

const SidebarMobile = ({ active }) => {
 const { toggleShowNav, toggleNavDisplay } = useContext(UserContext);
 return (
  <div
   className={
    toggleShowNav
     ? "dashboard left-bar mobile show"
     : "dashboard left-bar mobile "
   }
  >
   <div className="links-container">
    <div className="logo-container">
     <Link to="/">
      <img src={logo} alt="logo" />
     </Link>
     <div className="cancel-container" onClick={toggleNavDisplay}>
      <img src={cancel} alt="toggler" />
     </div>
    </div>
    <ul>
     <Link
      style={{
       backgroundColor: active === "home" ? "var(--secondary-color)" : "",
      }}
      to="/affiliate/dashboard"
     >
      <img src={home} alt="home" />
      <span>Home</span>
     </Link>
     <Link
      style={{
       backgroundColor: active === "product" ? "var(--secondary-color)" : "",
      }}
      to="/affiliate/dashboard/products"
     >
      <img src={product} alt="product" />
      <span>Product Marketplace</span>
     </Link>

     <Link
      style={{
       backgroundColor: active === "sales" ? "var(--secondary-color)" : "",
      }}
      to="/affiliate/dashboard/sales"
     >
      <img src={affiliate} alt="sales" />
      <span>Affiliate Sales</span>
     </Link>

     <Link
      style={{
       backgroundColor: active === "payouts" ? "var(--secondary-color)" : "",
      }}
      to="/affiliate/dashboard/payouts"
     >
      <img src={payouts} alt="payouts" />
      <span>Payouts</span>
     </Link>

     <Link
      style={{
       backgroundColor: active === "referral" ? "var(--secondary-color)" : "",
      }}
      to="/affiliate/dashboard/referral"
     >
      <img src={referral} alt="referral" />
      <span>Referral</span>
     </Link>

     <Link
      style={{
       backgroundColor: active === "settings" ? "var(--secondary-color)" : "",
      }}
      to="/affiliate/dashboard/settings"
     >
      <img src={settings} alt="settings" />
      <span>Settings</span>
     </Link>
    </ul>
   </div>
  </div>
 );
};

export default SidebarMobile;
